import { Component, HostBinding, OnInit } from '@angular/core';
declare var $: any;

import { SettingsService } from './core/settings/settings.service';

import 'reset-css/reset.css';
import { StoreService } from '@ngx-resource-toolkit/core';

import { SelectModel } from './shared/resource/select.model';
import { CourrielModel } from './courriel/models/courriel.model';
import { BulletinSearchModel } from './shared/examen/models/bulletin-recherche.model';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

    @HostBinding('class.layout-fixed') get isFixed() { return this.settings.layout.isFixed; };
    @HostBinding('class.aside-collapsed') get isCollapsed() { return this.settings.layout.isCollapsed; };
    @HostBinding('class.layout-boxed') get isBoxed() { return this.settings.layout.isBoxed; };
    @HostBinding('class.layout-fs') get useFullLayout() { return this.settings.layout.useFullLayout; };
    @HostBinding('class.hidden-footer') get hiddenFooter() { return this.settings.layout.hiddenFooter; };
    @HostBinding('class.layout-h') get horizontal() { return this.settings.layout.horizontal; };
    @HostBinding('class.aside-float') get isFloat() { return this.settings.layout.isFloat; };
    @HostBinding('class.offsidebar-open') get offsidebarOpen() { return this.settings.layout.offsidebarOpen; };
    @HostBinding('class.aside-toggled') get asideToggled() { return this.settings.layout.asideToggled; };
    @HostBinding('class.aside-collapsed-text') get isCollapsedText() { return this.settings.layout.isCollapsedText; };

    constructor(private settings: SettingsService, private storeService: StoreService) {
        console.log('AppComponent', 'CreateStore');
        this.storeService.createStore();

        // DO NOT REMOVE (load select data)
        const selectModel = new SelectModel();
        // J'ai pas trouvé d'autre méthode pour forcer l'ajout de courriel dans le store, comment ça se passe pour les autres univers §eleve, prof...) ?
        const courrielModel = new CourrielModel();
        const bulletinSearchModel = new BulletinSearchModel();
    }

    ngOnInit() {

    }
}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/app.component.ts